<template>
    <div>
        <div class="container p-0">
            <div class="card mb-2">
                <div class="card-body pt-3">
                    <div class="text-center text-muted border mb-3 py-2"><span>法人情報編集</span></div>

                    <!-- 会社名 -->
                    <form-input ref="name" :errs-nm="['name']" lab="会社名" plhd="例：会社名" :max-length="100" required has-len :disb="true"></form-input>

                    <!-- グループ名 -->
                    <form-input ref="user_group" :errs-nm="['user_group']" lab="グループ名" plhd="例：グループ名" required :max-length="100" has-len :disb="true"></form-input>

                    <!-- 会社ホームページURL -->
                    <form-input ref="url" :errs-nm="['url']" lab="ホームページURL" plhd="例：https://tech.promeraia.com" url :max-length="100" has-len></form-input>
                    
                    <!-- 国籍 -->
                    <form-input ref="country" :errs-nm="['country']" lab="国籍" plhd="例：日本" :max-length="30" has-len ></form-input>

                    <!-- 優先度 -->
                    <form-input ref="email_lev" ip-type="select" :errs-nm="['email_lev']" :s-opt="mailLevList" val-nm="val"
                                lab-nm="lab" dft="1" lab="優先度" required numeric :max-length="1"></form-input>

                    <!-- メール送信フラグ -->
                    <form-input ref="email_flg" ip-type="select" :errs-nm="['email_flg']" :s-opt="mailFlgList" val-nm="val"
                                lab-nm="lab" dft="0" lab="メール送信状態" required numeric :max-length="1"></form-input>

                    <!-- 担当者名 -->
                    <form-input ref="sales_name" :errs-nm="['sales_name']" lab="担当者名" plhd="例：田中" :max-length="20" has-len></form-input>

                    <!-- 配信宛先 -->
                    <form-input ref="sales_mail" ip-type="textarea" :errs-nm="['sales_mail']" lab="配信宛先" :row="3" plhd="複数メールアドレス入力可能です。" :max-length="500" has-len></form-input>

                    <form-input ip-type="comment" py0>
                        <i class="fas fa-info-circle"></i>
                        <span class="let-space-1">
                            複数送信先の場合、一行ずつ入力してくささい。
                        </span>
                    </form-input>

                    <!-- 配信CC -->
                    <form-input ref="sales_mail_cc" ip-type="textarea" :errs-nm="['sales_mail_cc']" lab="配信CC" :row="3" plhd="複数メールアドレス入力可能です。" :max-length="500" has-len></form-input>

                    <form-input ip-type="comment" py0>
                        <i class="fas fa-info-circle"></i>
                        <span class="let-space-1">
                            複数送信先の場合、一行ずつ入力してくささい。
                        </span>
                    </form-input>

                    <!-- システム備考 -->
                    <form-input ref="note" ip-type="textarea" :errs-nm="['note']" lab="備考" :row="5" plhd="必要に応じて記入してくさだい。" :max-length="500" has-len></form-input>

                    <div class="card mb-2 mt-5">
                        <div class="card-body">
                            <div class="row form-group justify-content-center mb-0">
                                <div class="col-sm-3 mb-3">
                                    <button class="btn btn-primary btn-block btn-lg" @click="backPage">
                                        <i class="fas fa-angle-left"></i>&nbsp;戻る
                                    </button>
                                </div>
                                <div class="col-sm-3 mb-3">
                                    <button class="btn btn-success btn-block btn-lg" @click="dataCheck">
                                        <i class="fas fa-eye"></i>&nbsp;確認画面へ
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import FormInput from 'pages/commons/form/Input'

    import {mapGetters} from 'vuex'

    export default {
        props: {
            opt: String
        },
        components: {
            FormInput,
        },
        data () {
            return {
                mailLevList: this.makeMailLevList(),
                mailFlgList: this.makeMailFlgList(),
                reqForm: {},
                resultArr: [],
                formArr:[
                         'name'
                        ,'user_group'
                        ,'url'
                        ,'country'
                        ,'email_lev'
                        ,'email_flg'
                        ,'sales_name'
                        ,'sales_mail'
                        ,'sales_mail_cc'
                        ,'note'
                    ],
            }
        },
        watch: {
            getCompanyDetail (info) {
                if (info.data.company_info) {
                    this.setDefaultVal(info.data.company_info)
                }
            }
        },
        computed: {
            ...mapGetters(['getCompanyDetail'])
        },
        methods: {
            backPage () {
                this.$parent.changeOperat('show')
            },
            setDefaultVal (info) {
                // 編集ボダン押下
                this.$refs.name.setInputData(info.name)
                this.$refs.user_group.setInputData(info.user_group)
                this.$refs.url.setInputData(info.url)
                if (info.country) {
                    this.$refs.country.setInputData(info.country)
                }
                this.$refs.email_lev.setInputData(info.email_lev)
                this.$refs.email_flg.setInputData(info.email_flg)
                if (info.sales_name) {
                    this.$refs.sales_name.setInputData(info.sales_name)
                }
                if (info.sales_mail) {
                    this.$refs.sales_mail.setInputData(info.sales_mail)
                }
                if (info.sales_mail_cc) {
                    this.$refs.sales_mail_cc.setInputData(info.sales_mail_cc)
                }
                if (info.note) {
                    this.$refs.note.setInputData(info.note)
                }
            },
            getChildData () {
                this.formArr.forEach(item => {
                    var formData = this.$refs[item].getData()
                    this.reqForm = Object.assign({},this.reqForm, formData)
                })
            },
            getData() {
                return this.reqForm
            },
            dataCheck () {

                  /** test 用start **/
                    //this.getChildData()
                    //this.$parent.getChildData()
                    //this.$parent.changeOperat('auto')
                  /** test 用end **/

                this.checkForm()
                this.doDataCheck ()
            },
            doDataCheck () {
                Promise.all(this.resultArr)
                    .then((res) => {
                        this.getChildData()
                        this.$parent.getChildData()
                        this.$parent.changeOperat('auto')
                    })
            },
            checkForm () {
                this.resultArr = []
                this.formArr.forEach(formName => {
                    this.doCheckForm(formName)
                })
            },
            doCheckForm (formName) {
                var result = new Promise((resolve, reject) => {
                    let valid = this.$refs[formName].dataCheck()           
                    if (valid) { 
                        resolve() }
                })
                this.resultArr.push(result)
            },
            makeMailLevList () {
                return this.$parent.getList('company_mail_lev')
            },
            makeMailFlgList () {
                return this.$parent.getList('company_mail_flg')
            },
        }
    }
</script>

<style>

</style>
